/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { useRoom } from '../../../hooks/useRoom';
import { participantAPI } from '../../../api/participant';
import { setCallDetails } from '../../../actions/callActions';
import { useInterval } from '../../../hooks/useInterval';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { get, isEqual } from '@utils/lodash';

const CALL_DETAILS_REFRESH_INTERVAL = 5000;

export const usePollParticipantCallDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { roomId } = useRoom();
  const callDetails = useRootSelector(state => state.callDetails);

  const fetchCallDetails = async () => {
    let call;
    try {
      call = await participantAPI.rooms.fetchCallDetailsForRoom(roomId);
      if (!isEqual(callDetails, call)) {
        setCallDetails(call)(dispatch);
      }
    } catch (e) {
      const status = get(e, 'response.status');
      if (status === 404) {
        // when participant session terminated, redirect participants to finish dialog
        history.push(`/rooms/${roomId}/finish`);
      } else {
        throw e;
      }
    }
  };

  useInterval(fetchCallDetails, CALL_DETAILS_REFRESH_INTERVAL);
};
